import type { CommandHandler } from '../types';

export const importBankStatementManagementCommandHandler: CommandHandler = (command, context) => {
  if (!context.openBankStatementManagementImportDialog) {
    return {
      success: false,
      error: 'Bank statement import dialog is not available.',
    };
  }

  context.openBankStatementManagementImportDialog(command);
  return { success: true };
};
